<template>
  <div>
    <section class="pb-24">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2
            class="text-[40px] font-bold text-slate-900 dark:text-white mb-4 cust-title"
          >
            {{ category.title }}
          </h2>
          <!-- <div class="w-[45%] h-1 bg-primary mx-auto"></div> -->

          <h6 class="mt-2">
            {{ category.message }}
          </h6>
        </div>
        <div class="gap-8">
          <div class="relative flex items-center">
            <button
              @click="prev"
              class="absolute -left-4 md:-left-10 z-10 p-2 text-gray-400 hover:text-blue-600 transition-colors"
            >
              <svg
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            <div class="overflow-hidden w-full">
              <div
                class="flex transition-transform duration-500 ease-in-out"
                :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
              >
                <div
                  v-for="(group, gIndex) in groupedProducts"
                  :key="gIndex"
                  class="w-full flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
                >
                  <div
                    v-for="(item, index) in group"
                    :key="index"
                    class="bg-white flex flex-col items-center shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div
                      class="w-full aspect-[4/3] flex items-center justify-center mb-4 overflow-hidden border border-gray-50"
                      @click="naviProducts(item)"
                    >
                      <img
                        :src="item.url"
                        class="object-contain cursor-pointer max-h-full hover:scale-110 transition-transform duration-500"
                        :alt="item.name"
                      />
                    </div>
                    <div class="text-center py-5">{{ item.message }}</div>
                  </div>
                </div>
              </div>
            </div>

            <button
              @click="next"
              class="absolute -right-4 md:-right-10 z-10 p-2 text-gray-400 hover:text-blue-600 transition-colors"
            >
              <svg
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>

          <div class="flex justify-center mt-8 space-x-2">
            <span
              v-for="(_, i) in groupedProducts"
              :key="i"
              class="w-2 h-2 rounded-full cursor-pointer transition-colors"
              :class="currentIndex === i ? 'bg-blue-600' : 'bg-gray-300'"
              @click="currentIndex = i"
            ></span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PopularCategories',
  components: {},
  props: {
    title: String,
    category: Object
  },
  data() {
    return {
      images: [
        'https://picsum.photos/id/10/600/400',
        'https://picsum.photos/id/11/600/400',
        'https://picsum.photos/id/12/600/400',
        'https://picsum.photos/id/13/600/400',
        'https://picsum.photos/id/14/600/400',
        'https://picsum.photos/id/15/600/400',
        'https://picsum.photos/id/16/600/400',
        'https://picsum.photos/id/17/600/400'
      ],
      currentIndex: 0,
      offset: 0,
      autoScrollSpeed: 1,
      autoScrollEnabled: true,
      animationFrameId: null,
      itemWidth: 304, // 288px (w-72) + 16px (px-2)
      categories: [
        {
          name: 'Keychains',
          desc: 'Delicate designs for valuable keys',
          img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBbR4GkEdxHlAeMWqpzu5BefKVmMDCHfEnSVCe1458FVOswGvZ5pQpfyWnCF_h_QVJ8z31vHzDQ8cPRbkyRgWWtlI9_PPNZrL1lMmeQGn4L5wb8HLaOIQObIky86koGSFSyLmXqHLPM_5ZZR7K7NxI4Ix7M56lZ-mr0WO-m5i7_uQIj1RqBVuWMTsgyfTsKlD58iaEqmQEXZAv2nWfnf1G9LqqpD6g7wO-b7gRLnUnb6JVKvY76uudKgK97wobQ8kxn02aMr67INOI'
        },
        {
          name: 'Badges',
          desc: 'Unique badges for particular memories',
          img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCTc6Lgq1RawAtlT4cOYjNACERrK_QWtwYyiWfTN-SB3wtS8mNiD_0lwulWPD-KDWW1hzMcW_fK0hVrFcs8IxYLz4XH9HRAWavXmIMqKFLmF9k8TvQt6aN3h-EygI9nO5YPoNn_arT_aapHgLxJS1XXHRpGVrUWr1M4ptfzGr-d__Vrj67znY-FPesMuoPBANN1WEm-SAVEvUKLxv_1ETcHmBEuO900HROYpocOiQdLKttPF5i1dd67WYfObSF7t6PtfSmzo31JJAI'
        }
      ]
    }
  },
  mounted() {
    // this.startAutoScroll()
  },
  computed: {
    // 关键逻辑：将数组切割为 4 个一组的二维数组
    groupedProducts() {
      const size = 4
      const groups = []
      for (let i = 0; i < this.category.images.length; i += size) {
        groups.push(this.category.images.slice(i, i + size))
      }
      return groups
    }
  },
  methods: {
    next() {
      if (this.currentIndex < this.groupedProducts.length - 1) {
        this.currentIndex++
      } else {
        this.currentIndex = 0 // 循环
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      } else {
        this.currentIndex = this.groupedProducts.length - 1 // 循环
      }
    },
    naviProducts(item) {
      // console.log(this.category.title)
      const purl = item.url
      const type = purl.slice(-3)
      this.$router.push({
        path: '/products-details',
        query: { n: item.message, l: this.category.title, t: type }
      })
      console.log(JSON.stringify(item))
    }
  },
  beforeDestroy() {
    // cancelAnimationFrame(this.animationFrameId)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/PopularCategoriesSection.vue